import { useRef } from 'react'

/**
 * Get a unique number key per mounted instance
 */
export function useGetMountUniqueKey(initialKey: number) {
    const keyRef = useRef(initialKey)
    return () => keyRef.current++
}
